var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11a3 3 0 013 3v9h7a3 3 0 110 6H24a3 3 0 01-3-3V14a3 3 0 013-3z",
    fill: "#35313F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6.26C14.203 6.26 6.26 14.204 6.26 24c0 9.797 7.943 17.74 17.74 17.74 9.797 0 17.74-7.943 17.74-17.74 0-9.797-7.943-17.74-17.74-17.74zM0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z",
    fill: "#35313F"
  })));
}

export default SvgTimeAlt;